// extracted by mini-css-extract-plugin
export default {"otp-extra-width":"Login_otp-extra-width__8IXgz"};